@if (loading) {
<p-skeleton #skeleton [size]="skeletonSize" height="2rem"></p-skeleton>
} @else {
<p-button
  #button
  [icon]="icon"
  [type]="type"
  [label]="label"
  [styleClass]="styleClass"
  (onClick)="handleClick($event)"
  [disabled]="disabled"
  [severity]="severity"
  [size]="size"
  [loading]="processing"
  [rounded]="rounded"
  [link]="link">
  <ng-content></ng-content>
</p-button>
}
